"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IToken", {
  enumerable: true,
  get: function get() {
    return _token.IToken;
  }
});
exports.createLexer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _token = require("./token");

var Tokenizer = function () {
  function Tokenizer(lexerConfig) {
    (0, _classCallCheck2["default"])(this, Tokenizer);
    this.lexerConfig = lexerConfig;
  }

  (0, _createClass2["default"])(Tokenizer, [{
    key: "tokenize",
    value: function tokenize(input) {
      var tokens = [];
      var token;
      var lastPosition = 0;

      while (input.length) {
        var result = this.getNextToken(input);

        if (!result || !result.token) {
          throw Error("Lexer: Unexpected string \"".concat(input, "\"."));
        }

        token = result.token;

        if (!token.value) {
          throw Error("Lexer: Regex parse error, please check your lexer config.");
        }

        token.position = [lastPosition, lastPosition + token.value.length - 1];
        lastPosition += token.value.length;
        input = input.substring(token.value.length);

        if (!result.config.ignore) {
          tokens.push(token);
        }
      }

      return tokens;
    }
  }, {
    key: "getNextToken",
    value: function getNextToken(input) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.lexerConfig[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var eachLexer = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = eachLexer.regexes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var regex = _step2.value;
              var token = this.getTokenOnFirstMatch({
                input: input,
                type: eachLexer.type,
                regex: regex
              });

              if (token) {
                return {
                  token: token,
                  config: eachLexer
                };
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
  }, {
    key: "getTokenOnFirstMatch",
    value: function getTokenOnFirstMatch(_ref) {
      var input = _ref.input,
          type = _ref.type,
          regex = _ref.regex;
      var matches = input.match(regex);

      if (matches) {
        return {
          type: type,
          value: matches[1]
        };
      }
    }
  }]);
  return Tokenizer;
}();

var createLexer = function createLexer(lexerConfig) {
  return function (text) {
    return new Tokenizer(lexerConfig).tokenize(text);
  };
};

exports.createLexer = createLexer;